export const translations = {
    fr: {
        common: {
            previous: 'Précédent',
            next: 'Suivant',
            incomplete: 'Incomplet',
            completeForm: 'Merci de bien compléter votre formulaire.',
            email: 'Email',
            back: 'Retour',
            loading: 'Chargement...',
            loadingData: 'Chargement des données...',
            validate: 'Valider',
            cancel: 'Annuler',
            confirmChoice: 'Désirez-vous confirmer votre choix ?',
            completeInfo: 'Merci de compléter cette information',
            supportContactError: 'Erreur veuillez contacter le support {email}',
            searchPlaceholder: 'Tapez votre recherche…',
            noResult: 'Aucun résultat',
        },
        footer: {
            copyright: 'Copyright {year} - {brand}',
            privacy: 'Vie privée',
            terms: 'Conditions générales',
            legal: 'Mentions légales',
            security: 'Sécurité des transactions',
        },
        menu: {
            dashboard: 'Tableau de bord',
            profile: 'Mon Profil',
            projects: 'Mes projets',
            contact: 'Contact',
            help: 'Aide',
            logout: 'Déconnexion',
        },
        header: {
            welcome: 'Bienvenue !',
            registrationStart: 'Votre inscription peut commencer',
            backToSite: 'Revenir sur le site',
            myAccount: 'Mon compte',
        },
        fil: {
            step1: 'Etape 1',
            step2: 'Etape 2',
            step3: 'Etape 3',
            chooseProject: 'Je choisis mon projet',
            globalongAccount: 'Compte {brand}',
            createFile: 'Création de mon dossier',
        },
        recap: {
            makeChoice: 'Merci de faire votre choix',
            amountToPay: 'Montant à verser :',
            totalAmountToPay: 'Montant total à verser pour ce projet :',
            yourSummary: 'Votre récapitulatif',
        },
        ident: {
            accessError: 'Erreur d\'accès',
            checkCredentials: 'Merci de vérifier votre email ou mot de passe.',
            provideEmail: 'Veuillez indiquer votre email.',
            sendNewPassword: 'Envoyer mon nouveau mot de passe',
            passwordSent: 'Mot de passe envoyé',
            password: 'Passe',
            passwordRequired: 'Votre passe est non renseigné.',
            login: 'Identification',
            forgotPassword: 'Mot de passe oublié ?',
            applyFirstProject: 'Candidater pour un premier projet',
            applyProject: 'Candidater pour un projet',
        },
        dashboard: {
            projectTitle: 'Projet Aide et soutien aux enfants hospitalisés',
            weNeedYou: 'Nous avons besoin de vous',
            lastStep: 'Une toute dernière étape avant la soumission de votre dossier.',
            refPrefix: 'Réf. #',
            departurePrefix: 'Départ le ',
            finalizeApplication: 'Finaliser ma candidature',
            clickToFinalize: 'Cliquez ici pour finaliser ma candidature',
            noRegistration: 'Aucune inscription en attente',
            noRegistrationDesc: 'Vous n\'avez pas d\'inscription en attente de soumission',
            greeting: 'Bonjour {name} ;)',
            followRegistrations: 'Suivez vos inscriptions et accédez à vos informations personnelles grâce au menu de gauche.',
        },
        orderDashboard: {
            mySteps: 'Mes étapes',
            registrationStatus: 'Statut de votre inscription & versement',
            actionRequired: 'Action requise de votre part : Versement de la cotisation d\'adhésion',
            actionRequiredSolde: 'Action requise de votre part : Versement du solde frais d\'inscription',
            lclPayment: 'Versement sécurisé par carte bancaire',
            lclPaymentDesc: 'Pour un versement par carte bancaire, veuillez cliquer sur une des icônes ci-dessous. Comptez entre 1 et 4 jours ouvrés pour la validation de votre versement par nos services. Passé ce délai, si vous n\'avez pas reçu de mail de confirmation de réception, merci de nous contacter.',
            stripePayment: 'Versement sécurisé par carte bancaire',
            stripePaymentDesc: 'Payez en ligne par carte bancaire de manière sécurisée. En cliquant sur le bouton ci-dessous, vous serez redirigé vers notre prestataire de paiement Stripe pour finaliser votre versement. Vous recevrez un mail de confirmation une fois le versement effectué.',
            payWithStripe: 'Payer par carte bancaire',
            mobilepayPayment: 'Versement sécurisé via MobilePay',
            mobilepayPaymentDesc: 'Payez en ligne avec MobilePay (Vipps) de manière sécurisée. En cliquant sur le bouton ci-dessous, vous serez redirigé vers MobilePay pour finaliser votre versement. Vous recevrez un mail de confirmation une fois le versement effectué.',
            payWithMobilepay: 'Payer avec MobilePay',
            wireTransfer: 'Versement par virement bancaire',
            wireTransferDesc: 'Afin d\'effectuer un versement par virement bancaire, utilisez nos coordonnées bancaires, que vous allez recevoir par mail, et procédez au virement via votre banque en ligne ou dans votre agence bancaire.',
            wireTransferWarning: 'Attention : il ne s\'agit pas d\'un prélèvement, vous devez effectuer la démarche auprès de votre banque.',
            wireTransferConfirm: 'Vous recevrez un mail de confirmation dès réception de votre versement sur notre compte. Cette opération peut durer quelques jours. Si vous n\'avez pas reçu le mail de confirmation de réception dans un délai de 7 jours, veuillez nous contacter.',
            validateWireTransfer: 'Valider mon versement par RIB',
            checkPayment: 'Versement par chèque',
            checkPaymentDesc1: 'Si vous souhaitez faire un versement par chèque bancaire, vous disposez d\'un délai de 15 jours pour l\'envoi et la réception du chèque. Au-delà de ce délai, sans réception de votre/vos chèque(s), le mode de versement sera annulé et il faudra recommencer.',
            checkPaymentDesc2: 'Pour la validation de votre versement par chèque, comptez environ 15 jours après réception de votre chèque. Vous recevrez ensuite un mail de confirmation de réception. Si vous n\'avez pas reçu de mail de confirmation passé un délai de 15 jours, veuillez prendre contact avec nos services.',
            checkPaymentWarning: 'Attention: le versement par chèque n\'est pas possible si votre programme commence dans moins de 8 semaines. Dans ce cas, merci de faire le versement par carte bancaire ou par virement bancaire.',
            validateCheckPayment: 'Valider mon versement par chèque',
            cotisationHappy: 'Nous sommes heureux de vous informer que votre candidature a été retenue.',
            cotisationP1: 'Afin de valider votre engagement, merci de verser la cotisation d\'adhésion à l\'association ({membershipFee}) pour devenir membre de l\'association {brand}. L\'adhésion est valable pendant 1 an, renouvelable gratuitement pendant 9 ans.',
            cotisationP2: 'Une fois le versement effectué, nous allons traiter votre inscription, et vous allez recevoir tous les documents et informations nécessaires à la préparation de votre projet.',
            thirdPartyQuestion: 'Une tierce personne souhaite faire un versement pour mon projet, comment faire ?',
            thirdPartyIntro: 'La majorité de nos bénévoles lèvent des fonds auprès de tierces personnes ou entreprises pour financer leur projet. Cela peut se faire des manières suivantes :',
            thirdPartyOption1: '1. Par carte bancaire sur votre espace membre',
            thirdPartyOption2: '2. Par virement bancaire - dans ce cas, vous recevez notre RIB par mail et les donateurs peuvent faire un ou plusieurs virements vers notre compte, en indiquant votre nom et prénom dans l\'objet du virement',
            thirdPartyOption3: '3. Par chèque, en indiquant dans le courrier que le versement est pour votre dossier',
            processingDelay: 'Le délai de traitement dépendra du mode de versement choisi.',
            contactHelp: 'Si vous avez des questions ou besoin d\'aide pour les étapes suivantes, merci de nous contacter par mail ou prendre un rendez-vous téléphonique',
            contactHelpLink: 'via ce lien.',
            acompteP1: 'Afin de valider votre engagement, merci de verser une première partie du budget de solidarité ({membershipFee}) pour que nous puissions commencer l\'organisation de votre projet. Ce montant sera déduit de la somme totale que nous sommes chargés de récolter pour votre projet.',
            acompteP2: 'Il ne s\'agit pas de la cotisation d\'adhésion à l\'association, que vous avez déjà versé (et qui a déjà été déduite), mais d\'un versement partiel du versement pour ce projet.',
            soldePay: 'Merci de verser le solde restant d\'un montant de {amount}',
            paymentPending: 'Versement en attente de validation',
            thanksPayment: 'Nous vous remercions pour votre versement et votre confiance.',
            uponReception: 'Dès réception de votre versement sur notre compte, nous validerons votre espace {brand} et vous enverrons un accusé de réception.',
            wireTransferTitle: 'Versement par virement bancaire :',
            notDirectDebit: 'd\'un prélèvement - veuillez contacter votre établissement bancaire pour effectuer votre virement sur le compte dont les coordonnées (RIB) sont les suivantes :',
            notDirectDebitPrefix: 'Il ne s\'agit pas',
            bankColumn: 'Banque',
            codeColumn: 'Indicatif',
            accountColumn: 'Numéro de compte',
            ribKey: 'Clé RIB',
            domiciliation: 'Domiciliation',
            accountHolder: 'Titulaire du compte :',
            intlIdent: 'IDENTIFICATION INTERNATIONALE',
            wireLabel: 'Dans le libellé du virement bancaire, merci de noter votre nom, prénom ainsi que la destination et référence de votre projet.',
            bankFees: 'Attention : si des frais liés au change ou à la transaction bancaire s\'appliquent, vous devez les prendre à votre charge.',
            contactByEmail: 'En cas de questions, contactez-nous par mail à l\'adresse',
            checkTitle: 'Versement par chèque (chèques français uniquement) :',
            checkInstruction: 'En cas de versement par chèque, veuillez envoyer votre/vos chèque(s), préalablement libellé(s) au nom de "{bankCheckPayee}", à l\'adresse suivante :',
            assocAddressLine1: '{bankAddressLine1}',
            assocAddressLine2: '{bankAddressLine2}',
            assocAddressLine3: '{bankAddressLine3}',
            checkOriginWarning: 'Veuillez noter que nous acceptons uniquement des chèques provenant d\'un établissement bancaire français. Nous ne pouvons pas accepter les chèques étrangers. Attention : le versement par chèque n\'est pas possible si votre programme commence dans moins de 8 semaines, à cause des délais de traitement. Dans ce cas, merci de faire le versement par carte bancaire ou par virement bancaire.',
            markName: 'Pensez à marquer votre nom et prénom ainsi que la référence de votre dossier au dos du chèque.',
            backToSteps: 'Revenir aux étapes',
            cotisationOrAcompte: 'Versement de la cotisation d\'adhésion / Versement de l\'acompte',
            remainingBalance: 'Versement du solde restant',
            applicationToComplete: 'Candidature à compléter',
            applicationInReview: 'Candidature en cours d\'étude',
            applicationAccepted: 'Candidature acceptée',
            cotisationPendingValidation: 'Versement de la cotisation d\'adhésion/de l\'acompte en attente de validation par nos services (1 à 7 jours selon le mode de versement)',
            firstPaymentValidated: 'Premier versement effectué et validé par nos services',
            balancePendingValidation: 'Versement du solde restant en attente de validation par nos services (1 à 7 jours selon le mode de versement)',
            balanceValidated: 'Versement du solde effectué et validé par nos services',
            projectFinalized: 'Projet finalisé',
            stripeInitError: 'Erreur lors de l\'initialisation du paiement Stripe.',
            stripeConnectError: 'Une erreur est survenue lors de la connexion à Stripe. Veuillez réessayer.',
            mobilepayInitError: 'Erreur lors de l\'initialisation du paiement MobilePay.',
            mobilepayConnectError: 'Une erreur est survenue lors de la connexion à MobilePay. Veuillez réessayer.',
        },
        order: {
            myProjects: 'Liste de mes projets',
            projectsDesc: 'Vous trouverez ci-dessous vos candidatures, futurs projets, projets en cours, anciens projets et projets annulés. ',
            tabApplications: 'Candidatures',
            tabInProgress: 'Mes projets en cours',
            tabFinished: 'Projets terminés',
            tabCancelled: 'Candidatures/projets annulées',
            titleApplications: 'Mes candidatures',
            titleValidated: 'Mes projets validés',
            titleFinished: 'Projets terminés',
            titleCancelled: 'Candidatures/projets annulées',
        },
        orderDetail: {
            myProjectPrefix: 'Mon projet : ',
            programType: 'Type de programme :',
            project: 'Projet :',
            applicationStatus: 'Statut du dossier de candidature :',
            startDate: 'Date de début :',
            endDate: 'Date de fin :',
            totalBudget: 'Budget total pour votre projet',
            amount: 'Montant',
            remainingAmount: 'Montant restant à verser :',
            paymentDeadline: 'Date limite de versement :',
            visaTitle: 'Règles de visa et d\'immigration en vigueur',
            visaDesc: 'Les règles de visa et d\'immigration en vigueur varient selon votre nationalité. Veuillez effectuer les démarches pour prendre connaissance des règles qui s\'appliquent à votre situation. Vous pouvez également nous contacter pour en savoir plus.',
            tabStatus: 'Statut',
            tabMyData: 'Mes données',
            tabMyDocuments: 'Mes documents',
            tabMyPayments: 'Mes versements',
            tabOutboundFlights: 'Vol(s) aller',
            tabReturnFlights: 'Vol(s) retour',
            completeApplication: 'Merci de compléter votre candidature',
            completeApplicationButton: 'Compléter ma candidature',
            supplement: 'Supplément : ',
        },
        orderBlocDetails: {
            profileUpdated: 'Votre profil est à jour, merci.',
            passportNumber: 'N° de passeport',
            passportPlace: 'Lieu de délivrance du passeport',
            passportFullName: 'Nom(s) et prénom(s) exacts sur le passeport',
            passportIssueDate: 'Date de délivrance du passeport',
            passportExpiry: 'Date d\'expiration du passeport',
            visaNumber: 'N° de visa',
            insuranceCompany: 'Compagnie d\'assurance voyage',
            insurancePolicy: 'N° de contrat d\'assurance voyage',
            additionalNotes: 'Notes complémentaires',
            validateInfo: 'Valider mes informations',
        },
        orderComplete: {
            applicationSubmitted: 'Votre candidature a été déposée et sera étudiée sous peu.',
            averageReviewTime: 'En moyenne, les candidatures sont étudiées en moins de 7 jours ouvrés.',
            longerDelays: 'Dans certains cas, les délais peuvent être plus longs, n\'hésitez pas à nous contacter si besoin :',
            congratulations: 'Félicitations',
            accessMember: 'Accès à mon espace membre',
            almostThere: 'Nous y sommes presque ^_^',
            afterValidation: 'Après la validation de ce formulaire votre candidature sera soumise à {brand}',
            submitApplication: 'Soumettre ma candidature',
        },
        dashboardCmd: {
            startPrefix: 'Début le ',
            finalizeApp: 'Finaliser la candidature',
            firstPaymentNeeded: 'Merci de procéder au premier versement pour valider votre inscription.',
            acceptedProjects: 'Projet(s) Accepté(s)',
            validateFirstPayment: 'Valider le premier versement',
            infoAndDocs: 'Informations (vols,visa etc...) et documents',
            completeInfoAndDocs: 'Merci de bien vouloir compléter si ce n\'est pas déjà fait les informations et de transmettres les documents.',
            confirmedProjects: 'Projet(s) confirmé(s)',
            checkOrComplete: 'Vérifier ou compléter mon inscription',
        },
        listeCmd: {
            reference: 'Référence : ',
            country: 'Pays',
            notSpecified: 'Non précisé',
            seeDetails: 'Voir le détail',
            validateLastStep: 'Cliquez ici afin de valider la dernière étape de votre candidature.',
            additionalInfoRequired: 'Informations complémentaires requises',
        },
        orderFiles: {
            updateDocs: 'Mise à jour de vos documents',
            checkingDocs: 'Nous vérifions la bonne réception de vos documents.',
            fileUploaded: 'Merci votre fichier a bien été chargé.',
            fileFormat: 'Il faut que le fichier soit au format PDF,JPEG,PNG, DOC ou DOCX (format Word)',
            maxSize: 'Ne doit pas dépasser 35Mo !',
            docTypeNotSpecified: 'Type de document non précisé',
            specifyDocType: 'Merci de préciser le type de document',
            fileAlreadyLoaded: 'Le fihier est déjà chargé',
            fileAlreadyLoadedDesc: 'Si vous souhaitez le charger à nouveau, il faudra le supprimer',
            uploadDocs: 'Charger vos documents',
            docTypePlaceholder: 'Type de document',
            internship: 'Convention de stage',
            planeTicket: 'Billet d\'avion',
            visa: 'Visa',
            other: 'Autre',
            add: 'Ajouter',
            docState: 'Etat des documents déposés',
            legendStates: 'Légende sur les états',
            docNotLoaded: 'Document non chargé',
            docPendingValidation: 'Document en attente de validation par {brand}',
            docValidated: 'Document validé',
            docValidatedTooltip: 'Votre document est validé',
            docPendingTooltip: 'Votre document est en attente',
            docNeedsUpload: 'Merci de charger le document',
            docsAvailable: 'Documents mise à disposition :',
            missionDocs: 'Documents de la mission :',
        },
        orderFlight: {
            flightNum: 'Numéro du vol',
            flightCompany: 'Compagnie du vol',
            takeoffDateTime: 'Date et heure de décollage ',
            arrivalDateTime: 'Date et heure d\'arrivée',
            depAirport: 'Aéroport de provenance',
            arrAirport: 'Aéroport d\'arrivée',
            missingInfo: 'Information manquantes',
            missingInfoSingular: 'Information manquante',
            update: 'Mettre à jour',
            delete: 'Supprimer',
            addFlight: 'Ajouter un vol',
            numAndCompany: 'Le N° et la compagnie',
            iLeaveFrom: 'Je pars depuis ',
            iArriveAt: 'J\'arrive à',
            depAirportPlaceholder: 'Aéroport de provenance (dernier aéroport avant arrivée)',
            takeoffPlaceholder: 'Date et heure de décollage',
            landingPlaceholder: 'Date et heure d\'atterissage',
            validateFlights: 'Valider mes vols',
            myFlights: 'Liste de mes vols',
            loading: 'En chargement...',
            notif: 'Notification ',
            flightsAdded: 'Vol(s) ajouté(s).',
            flightUpdated: 'Votre vol est à jour avec les nouvelles informations.',
            additionalInfo: 'Informations supplémentaires',
            giveDetails: 'Merci de nous donner des détails supplémentaires',
            selectReason: 'Veuillez sélectionner un motif.',
            cancelMyReason: 'Annuler mon motif ',
            reasonUpdated: 'Motif mis à jour',
            reasonUpdatedDesc: 'Nous vous confirmons la mise à jour du motif.',
            reasonCancelled: 'Motif annulé',
            reasonCancelledDesc: 'Nous vous confirmons l\'annulation du modif.',
            outboundHeader: 'J\'arrive dans le pays avant la mission et n\'ai pas besoin d\'accueil à l\'aéroport',
            returnHeader: 'Je reste dans le pays après la mission et n\'ai pas besoin d\'être raccompagné à l\'aéroport',
            importantInfo: 'IMPORTANT – Veuillez impérativement respecter les jours et heures d\'arrivée et de départ indiqués dans les documents disponibles sur votre espace membre.',
            contactBeforeBuy: 'En cas de doute ou de question, n\'hésitez pas à nous contacter avant de procéder à l\'achat de votre billet.',
            outboundReasonTitle: 'Si vous ne pouvez pas respecter les dates et horaires de départ prévus pour la mission, et que votre programme inclut un retour vers l\'aéroport (merci de vérifier les conditions de votre projet), veuillez choisir l\'une des options suivantes :',
            outboundReason1: 'Arrivée anticipée sans accueil : Je serai dans le pays avant le début de la mission et n\'ai pas besoin d\'accueil à l\'aéroport. Je prendrai contact avec l\'équipe locale pour organiser mon arrivée de manière autonome',
            outboundReason2: 'Arrivée anticipée avec accueil exceptionnel : Je serai dans le pays avant le début de la mission et souhaiterais bénéficier d\'un accueil à l\'aéroport, ainsi qu\'ajouter des nuitées supplémentaires (sous réserve de disponibilité, des frais supplémentaires peuvent être appliqués)',
            outboundReason3: 'Arrivée retardée avec accueil différé : J\'arrive après la date initialement prévue et souhaite solliciter un accueil différé à l\'aéroport (sous réserve de disponibilité, des frais supplémentaires peuvent être appliqués)',
            returnReasonTitle: 'Si vous ne pouvez pas respecter les dates et horaires d\'arrivée prévus pour la mission, et que votre programme inclut un accueil à l\'aéroport (merci de vérifier les conditions de votre projet), veuillez choisir l\'une des options suivantes :',
            returnReason1: 'Départ anticipé avec accompagnement exceptionnel : Je quitterai le pays avant la fin de la mission et souhaiterais bénéficier d\'un accompagnement à l\'aéroport  (sous réserve de disponibilité, des frais supplémentaires peuvent être appliqués)',
            returnReason2: 'Départ retardé avec accompagnement différé : Je quitterai le pays après la date initialement prévue et souhaite solliciter un accompagnement différé à l\'aéroport et ajouter des nuitées supplémentaires dans l\'hébergement  (sous réserve de disponibilité, des frais supplémentaires peuvent être appliqués)',
            returnReason3: 'Séjour prolongé pour voyage personnel : Je resterai dans le pays après la fin de la mission pour voyager et n\'aurai pas besoin d\'être raccompagné à l\'aéroport',
        },
        orderMsg: {
            backToOrder: 'Revenir sur ma commande',
            paymentRegistered: 'Versement enregistré',
            paymentRegisteredDesc: 'Merci nous allons procéder très rapidement à la vérification de votre versement.',
            paymentRefused: 'Versement non accepté',
            paymentRefusedDesc: 'Votre versement n\'a pas été finalisé, merci de vous rapprocher du support de {brand} ou de votre banque.',
            error: 'Erreur',
            errorDesc: 'Nous n\'avons pas identifié le retour de la commande, merci de prendre contact avec le support.',
        },
        orderTransactions: {
            declarationSent: 'Merci, votre déclaration a bien été transmise',
            lastName: 'Nom',
            firstName: 'Prénom',
            fillInfo: 'Merci de remplir cette information',
            denomination: 'Dénomination',
            legalForm: 'Forme juridique',
            siren: 'SIREN',
            multiDonators: 'Si plusieurs personnes ont fait des dons pour votre projet, par exemple, via une cagnotte en ligne, veuillez nous contacter au téléphone ou par mail pour connaitre la marche à suivre pour obtenir les reçus fiscaux.',
            youAre: 'Vous êtes',
            individual: 'Un particulier',
            company: 'Une entreprise',
            emailInvalid: 'Le format du mail est incorrect ou non renseigné.',
            streetNumber: 'Numéro de rue',
            streetName: 'Nom de rue',
            postalCode: 'Code Postal',
            city: 'Commune',
            paymentDate: 'Date du paiement',
            confirmCheck: 'Merci de cocher cette case pour confirmer votre saisie',
            declarationStatement: 'Par la présente, je soussigné(e) (Prénom et Nom du client) déclare sur l\'honneur que les informations fournies dans la présente déclaration sont exactes et complètes.',
            validateDeclaration: 'Valider votre déclaration',
            id: 'Id',
            amount: 'Montant',
            date: 'Date',
            state: 'Etat',
        },
        contact: {
            contactUs: 'Nous contacter',
            desc1: 'Vous pouvez nous envoyer un message grâce au formulaire ci-dessous, nous répondrons par mail dans les meilleurs délais.',
            desc2: 'Vous pouvez également prendre un rendez-vous téléphonique via ce lien : ',
            desc3Before: ' ou nous appeler au ',
            desc3After: ' pendant nos horaires d\'ouverture.',
            desc4: 'Si vous êtes en mission, merci de contacter votre coordinateur en priorité pour toute urgence.',
            sendMyMsg: 'Envoyer ma demande',
            msgSent: 'Merci, nous vous confirmons l\'envoi de votre message, une réponse vous sera donnée très rapidement !',
        },
        passport: {
            formSent: 'Formulaire envoyé avec succès !',
            formError: 'Erreur lors de l\'envoi du formulaire',
            fillAllFields: 'Veuillez remplir tous les champs correctement.',
            alreadyOrdered: 'Commande déjà effectuée',
            alreadyOrderedDesc: 'Votre commande de passeport bénévolat a déjà été soumise.',
            orderSuccess: 'Commande réussie',
            orderSuccessDesc: 'Votre commande de passeport bénévolat a été envoyée avec succès. Merci de votre confiance !',
            getFreeTitle: 'Obtenez votre passeport bénévole gratuitement !',
            getFreeDesc: 'Ce document officiel vous permet de valoriser vos expériences bénévoles et de faire reconnaître les compétences que vous avez acquises. Recommandé par les employeurs et les associations, il est un atout pour votre parcours personnel et professionnel. {brand} vous l\'offre, ainsi que les frais d\'envoi.',
            clickToReceive: 'Cliquez ci-dessous pour le recevoir dès maintenant !',
            learnMore: 'En savoir plus: ',
            volunteerPassport: 'Le Passeport Bénévole',
            orderMyPassport: 'Commander mon passeport bénévolat',
            orderTitle: 'Commandez votre passeport bénévolat',
            civility: 'Civilité',
            selectCivility: 'Veuillez sélectionner la civilité.',
            selectCivilityPlaceholder: 'Sélectionnez votre civilité',
            enterName: 'Veuillez saisir le nom.',
            enterFirstName: 'Veuillez saisir le prénom.',
            phone: 'Téléphone',
            enterPhone: 'Veuillez saisir le numéro.',
            numberPlaceholder: 'Numéro',
            streetAndNum: 'Numéro et nom de rue',
            enterStreet: 'Veuillez saisir la rue.',
            street: 'Rue',
            postalCode: 'Code postal',
            enterPostalCode: 'Veuillez saisir le code postal.',
            enterCity: 'Veuillez saisir la ville.',
            countryFranceOnly: 'Pays (Uniquement possible en France)',
            selectCountry: 'Veuillez sélectionner le pays.',
            countryPlaceholder: 'Sélectionnez votre pays',
            formNotice: 'Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par l\'association {brand} pour l\'envoi du document par courrier.',
            acceptTerms: 'Vous devez accepter les termes pour continuer.',
            acceptDataUse: 'J\'accepte que mes données soient utilisées pour l\'envoi du document par courrier.',
            validateOrder: 'Valider la commande de passeport bénévolat',
        },
        memberAdhesion: {
            updateError: 'Erreur lors de la mise à jour du membre',
            renewError: 'Erreur lors du renouvellement de l\'adhésion',
            networkError: 'Erreur réseau lors du renouvellement de l\'adhésion',
            confirmationRequired: 'Confirmation annuelle d\'adhésion requise',
            adhesionValidity: 'Votre adhésion reste valable pour 9 ans, sans frais supplémentaires. Merci de confirmer que vous souhaitez toujours faire partie de notre association.',
            renewAdhesion: 'Renouveler l\'adhésion',
        },
        profil: {
            title: 'Vos informations',
            desc: 'Vous pouvez modifier certaines informations vous concernant depuis cette page. Si vous souhaitez apporter une modification aux informations non modifiables, merci de nous contacter par mail. ',
            usernameRequired: 'Please input your username!',
            mr: 'Monsieur',
            mme: 'Madame',
            password: 'Mot de passe',
            providePassword: 'Merci de renseigner votre mot de passe.',
            passwordMinLength: 'Votre mot de passe doit contenir au minimum 8 caractères.',
            confirmPassword: 'Confirmer le mot de passe',
            confirmPasswordRule: 'Merci de confirmer votre mot de passe.',
            samePasswordRule: 'Merci de renseigner le même mot de passe en confirmation.',
            birthDate: 'Date de naissance',
            nationality: 'Nationalité',
            address: 'Adresse',
            cp: 'CP',
            mobilePhone: 'Téléphone portable',
            landline: 'Téléphone fixe',
            proSituation: 'Situation professionnelle actuelle',
            facebook: 'Facebook',
            remarks: 'Remarques',
            emailTrackingConsent: 'J\'accepte que {brand} mesure l\'ouverture de ses emails (via un pixel de suivi) afin d\'améliorer la pertinence de ses communications. Ce suivi est facultatif et révocable à tout moment.',
            loading: 'chargement...',
        },
        formRegister: {
            emailExists: 'Un compte existe déjà avec cette adresse email, merci de vous faire envoyer un nouveau mot de passe via "Mot de passe perdu"',
            missingInfo: 'Il manque des informations merci de bien compléter le formulaire.',
            emailTrackingConsent: 'J\'accepte que {brand} mesure l\'ouverture de ses emails (via un pixel de suivi) afin d\'améliorer la pertinence de ses communications. Ce suivi est facultatif et révocable à tout moment depuis mon profil.',
            thanksCreated: 'Merci d\'avoir créé votre espace {brand}. ',
            spaceAllowsYou: 'Votre espace {brand} vous permet :',
            allow1: 'De candidater pour un projet de bénévolat ou de vous inscrire pour une formation linguistique',
            allow2: 'De communiquer avec notre équipe',
            allow3: 'De nous fournir les informations importantes concernant votre projet',
            allow4: 'De télécharger des documents importants à la préparation de votre projet',
            allow5: 'De nous fournir les documents indispensables avant votre arrivée dans le pays d\'accueil',
            allow6: 'De verser la cotisation d\'adhésion et verser le/les dons',
            navigationHelp: 'En naviguant dans le menu à gauche de votre espace {brand}, vous pouvez modifier votre profil, compléter vos informations, voir l\'état de votre dossier et de vos versements ou encore nous contacter.',
            moreInfo: 'Pour plus de renseignements, n\'hésitez pas à nous contacter à l\'adresse',
            phoneAppointment: 'Nous pouvons également convenir d\'un rendez-vous téléphonique pour en discuter de vive voix.',
            clickAvailability: 'Cliquez ici pour voir nos disponibilités',
            andBook: 'et prendre rendez-vous.',
            bestRegards: 'Cordialement,',
            globalongTeam: 'L\'équipe {brand}',
            backToRegistration: 'Retour à l\'inscription',
            title: 'Formulaire d\'inscription',
            dateFormat: 'Date au format JJ/MM/YYYY',
            countryBirth: 'Pays de naissance',
            validEmail: 'Merci de renseigner un email valide',
            permanentAddress: 'Adresse permanente',
            phonePrefixRequired: 'Indicatif du téléphone obligatoire',
            preferredPrefixes: 'Indicatifs courants',
            allCountries: 'Tous les pays',
            phoneExample: 'Exemple : 06XXXXXXXX',
            emergencyContact: 'Personne à contacter en cas d\'urgence',
            volunteerLink: 'Lien avec le volontaire',
            emergencyPhone: 'Téléphone en cas d\'urgence',
            emergencyEmail: 'Email en cas d\'urgence',
            proSection: 'Votre situation professionnelle',
            currentProSituation: 'Votre situation professionnelle actuelle',
            otherProSituation: 'Si vous ne trouvez pas votre situation professionnelle actuelle sur la liste ci-dessus, merci de nous la préciser',
            departureProSituation: 'Votre situation au moment du départ (si différente)',
            otherDepartureProSituation: 'Si vous ne trouvez pas votre situation professionnelle au moment du départ sur la liste ci-dessus, merci de nous la préciser',
            termsAcceptIntro: 'J\'ai lu et j\'accepte les ',
            termsLabel: 'conditions générales',
            withoutReserve: ' sans réserve, j\'ai pris connaissance des ',
            legalNoticeLabel: 'mentions légales',
            committedTo: ' et je m\'engage à respecter le ',
            internalRulesLabel: 'règlement intérieur',
            yesAccept: 'Oui, j\'accepte',
        },
        methodeReg: {
            noAccount: 'Je n\'ai pas de compte',
            createAccount: 'Créer mon compte',
            haveAccount: 'J\'ai déjà un compte',
            signIn: 'S\'identifier',
        },
        step1: {
            registrationTitle: 'En route ! Votre inscription ;)',
            infoNotes: 'Informational Notes',
            infoNotesDesc: 'Nous ne pouvons étudier qu\'une seule candidature par dates et par personne.\nIl n\'est pas possible de candidater pour plusieurs projets aux mêmes dates.\nSi la candidature sur votre premier choix n\'est pas retenue, vous pourrez candidater pour d\'autres projets, et nous serons là pour vous guider.\nPour toute question, n\'hésitez pas à nous contacter. ',
            stepOf: 'Etape 1/3',
            chooseProjectDateDuration: 'Je choisis mon projet, la date de début et la durée ',
        },
        step3: {
            accountCreation: 'Création de mon compte',
            almostThere: 'Nous y sommes presque !',
        },
        orderCheck: {
            startDatePrefix: 'Date de début : ',
            destinationCountryPrefix: 'Pays de destination : ',
            programTypePrefix: 'Type du programme : ',
            programNamePrefix: 'Nom du programme : ',
            engagementDurationPrefix: 'Durée d\'engagement : ',
            supplementPrefix: 'Supplément : ',
            totalDurationPrefix: 'Durée totale de votre projet : ',
            weeks: ' semaine(s)',
            amountLib: 'Montant à verser ',
            totalAmountLib: 'Montant total à verser ',
            forThisProject: 'pour ce projet si votre candidature est acceptée : ',
            questionPrefix: 'Question : ',
            answerPrefix: ' / Votre réponse réponse : ',
            additionalAnswerPrefix: '/ Complément : ',
            recapTitle: 'Récapitulatif de votre candidature',
            recapDesc: 'Cette étape est la dernière et va nous permettre de vous donner les informations princpales sur votre inscription',
            projectDetails: 'Détails de votre projet',
            questionsAndAnswers: 'Questions et réponses',
            backToPreviousStep: 'Retour sur l\'étape précédente',
            openApplication: 'Ouvrir mon dossier de candidature',
        },
        inscrTermine: {
            hello: 'Bonjour {name},',
            confirmedTitle: 'Ouverture de dossier confirmé',
            langueOpening: 'Vous venez d\'ouvrir un dossier pour candidater pour un projet avec l\'association {brand} et nous vous remercions pour votre confiance.',
            validateBelow: 'Veuillez valider votre candidature ci-dessous.',
            responseDelay: 'Vous recevrez une réponse sous 1 à 7 jours ouvrés. En attendant, contactez-nous si vous avez des questions.',
            mustComplete: 'Afin de finaliser la candidature, vous devez déposer un dossier de candidature en déposant les documents listés ci-dessus via votre espace membre.',
            applicationContent: 'Votre dossier doit être constitué de :',
            yourCV: '1. Votre CV',
            presentationLetterIntro: '2. Une lettre de présentation dans laquelle vous répondrez aux questions suivantes :',
            whyLeave: 'Pourquoi souhaitez-vous partir ?',
            whyCountry: 'Pourquoi avez-vous choisi ce pays et ce projet ?',
            qualifications: 'Quelles qualifications ou expériences en rapport avec la mission avez-vous ?',
            expectations: 'Qu\'attendez-vous de la mission ?',
            criminalRecord: '3. Pour les missions de bénévolat et stages : un extrait de casier judiciaire.',
            documentsLanguageTitle: 'La lettre et le CV doivent impérativement être rédigés :',
            documentsLanguageFr: '- en français pour le Togo, le Maroc, Madagascar et le Sénégal',
            documentsLanguageEs: '- en espagnol pour les pays hispanophones (ou en anglais si vous êtes débutant en espagnol)',
            documentsLanguageEn: '- en anglais pour toutes les autres destinations',
        },
        dateOpen: {
            packsAvailable: 'Packs disponibles',
            datesAvailable: 'Dates disponibles',
            full: ' (Complet)',
            clickToChooseWeeks: 'Cliquez ici pour choisir la durée en nombre de semaines',
            chooseEngagementDuration: 'Choisissez la durée de votre engagement',
            otherDurationContact: 'Pour toute autre durée, contactez nous',
            whenStart: 'Autour de quelle date souhaiteriez-vous commencer ?',
            closestDatesList: 'Liste des dates les plus proches de votre choix',
            selectDateToContinue: 'Merci de sélectionner une date pour pouvoir avancer à l\'étape suivante',
        },
        docsInscr: {
            mustBeWrittenIn: 'Vos documents doivent être rédigés en : ',
            languageTitle: 'Langue des documents',
            missingDocs: 'Documents manquants',
            cvAndLetterRequired: 'Le CV et la lettre de présentation sont obligatoires',
            requiredDocs: 'Documents nécessaires',
            participateIntro: 'Pour participer à un programme de bénévolat, de volontariat international où à un stage à l\'étranger, vous devez constituer un dossier de candidature en déposant les documents ci-dessus.',
            applicationConsistOf: 'Votre dossier doit être constitué de :',
            yourCV: '1. Votre CV',
            letterIntro: '2. Une lettre de présentation dans laquelle vous répondrez aux questions suivantes :',
            whyVolunteer: '* Pourquoi souhaitez-vous faire du bénévolat ?',
            whyCountryMission: '* Pourquoi avez-vous choisi ce pays et cette mission ?',
            qualifications: '* Quelles qualifications ou expériences en rapport avec la mission avez-vous ?',
            expectations: '* Qu\'attendez-vous de la mission ?',
            whenStart: '* Quand souhaitez-vous commencer ?',
            howManyWeeks: '* Combien de semaines souhaitez-vous partir ?',
            criminalRecord: '3. Un extrait de casier judiciaire.',
            languageIntro: 'La lettre et le CV doivent impérativement être rédigés :',
            languageFr: '- en français pour le Togo, le Maroc, Madagascar et le Sénégal',
            languageEs: '- en espagnol pour les pays hispanophones (ou en anglais si vous êtes débutant en espagnol)',
            languageEn: '- en anglais pour toutes les autres destinations',
            cvLib: 'CV',
            letterLib: 'Lettre de présentation',
            criminalRecordLib: 'Casier judiciaire',
            criminalRecordInfoTitle: 'Information casier judiciaire',
            criminalRecordInfoDesc: 'Le casier judiciaire n\'est pas indispensable pour cette étape du dépôt de votre candidature, mais devra être fourni avant le début de votre projet. Les autres documents (CV et Lettre de présentation) sont obligatoires.',
        },
        accompagnateur: {
            withOthers: 'Est-ce que vous candidatez avec une ou plusieurs personnes ?',
            individualApp: 'A noter que chaque personne doit envoyer une candidature individuelle. Assurez-vous de candidater pour la même mission, aux mêmes dates.',
            yourCompanions: 'Vos accompagnateurs',
            erase: 'Effacer',
            updated: 'Accompagnateur mis à jour',
            updatedDesc: 'Les informations des accompagnateurs ont été mises à jour.',
            addNewPerson: 'Ajouter une nouvelle personne',
            missingFirstName: 'Il manque le prénom',
            missingLastName: 'Il manque le nom',
            missingEmail: 'Il manque le mail',
            addPerson: 'Ajouter une personne',
            validateCompanions: 'Valider mes accompagnateurs',
        },
        contactTel: {
            previousContact: 'Avez-vous déjà eu un contact téléphonique avec l\'association {brand} ?',
            choice: 'Choix',
            yes: 'oui',
            no: 'non',
            bookAppt: 'Merci de prendre un rendez-vous téléphonique à votre convenance via ce lien : ',
            whileWaiting: 'En attendant l\'échange téléphonique, vous pouvez continuer en appuyant sur « suivant » et déposer votre candidature :)',
        },
        questionBloc: {
            chooseAnswer: 'Choisir ma réponse',
            specifyAnswer: 'Merci de préciser votre réponse',
            required: 'Cette information est obligatoire',
            subQuestionsUnavailable: 'Sous question non disponibles',
        },
        questions: {
            pleaseAnswer: 'Merci de répondre aux questions',
            loading: 'En chargement....',
        },
        blockSejour: {
            selected: 'Séjour sélectionné',
            selectThis: 'Sélectionner ce programme',
        },
        choixTypeSejour: {
            chooseType: 'Je choisis mon type de projet',
            combined: 'Combiné',
            combinedDesc: 'Pour combiner une formation linguistique avec un projet de bénévolat ou un stage',
            volunteer: 'Bénévolat',
            volunteerDesc: 'Pour candidater pour une mission de bénévolat ou un stage',
            language: 'Formation linguistique',
            languageDesc: 'Pour apprendre ou améliorer une langue étrangère',
        },
        supp: {
            optionalSupplements: 'Compléments au choix',
        },
        choixSejour: {
            programChoice: 'Choix du programme',
        },
        destination: {
            title: 'Ma destination',
            choose: 'Choisir',
        },
        step2: {
            titleHeader: 'Etape 2/3',
            subtitle: 'Nous avons besoin de votre connaitre un peu mieux',
        },
        home: {
            backToSite: 'Retour sur le site {brand}',
        },
        stripeReturn: {
            backToOrder: 'Revenir sur ma commande',
            successTitle: 'Versement validé',
            successSubtitle: 'Merci, votre versement par carte bancaire (Stripe) a bien été enregistré. Vous allez recevoir un email de confirmation sous peu.',
            cardDeclinedTitle: 'Carte refusée',
            cardDeclinedSubtitle: 'Votre carte bancaire a été refusée par votre banque. Veuillez réessayer avec une autre carte ou contacter votre établissement bancaire.',
            expiredTitle: 'Carte ou session expirée',
            expiredSubtitle: 'Votre carte bancaire ou votre session de paiement a expiré. Veuillez relancer un versement avec une carte valide depuis votre espace membre.',
            insufficientFundsTitle: 'Solde insuffisant',
            insufficientFundsSubtitle: 'Votre carte bancaire ne dispose pas d\'un solde suffisant pour finaliser ce versement. Veuillez réessayer avec une autre carte ou contacter votre banque.',
            incorrectCvcTitle: 'Code de sécurité incorrect',
            incorrectCvcSubtitle: 'Le code de sécurité (CVC) saisi est incorrect. Veuillez vérifier les informations de votre carte et réessayer.',
            incorrectNumberTitle: 'Numéro de carte incorrect',
            incorrectNumberSubtitle: 'Le numéro de carte bancaire saisi est incorrect. Veuillez vérifier les informations de votre carte et réessayer.',
            processingErrorTitle: 'Erreur de traitement',
            processingErrorSubtitle: 'Une erreur est survenue lors du traitement de votre paiement. Veuillez réessayer dans quelques instants.',
            authRequiredTitle: 'Authentification requise',
            authRequiredSubtitle: 'Votre banque exige une authentification supplémentaire (3D Secure) qui n\'a pas été validée. Veuillez relancer le versement et finaliser l\'authentification auprès de votre banque.',
            doNotHonorTitle: 'Paiement refusé par votre banque',
            doNotHonorSubtitle: 'Votre banque a refusé l\'opération sans motif spécifique. Veuillez contacter votre établissement bancaire ou réessayer avec une autre carte.',
            unusableCardTitle: 'Carte non utilisable',
            unusableCardSubtitle: 'Cette carte ne peut pas être utilisée pour ce versement. Veuillez utiliser une autre carte ou contacter votre établissement bancaire.',
            tryAgainTitle: 'Veuillez réessayer plus tard',
            tryAgainSubtitle: 'Le paiement n\'a pas pu être traité par votre banque. Veuillez réessayer dans quelques minutes.',
            cancelledTitle: 'Versement annulé',
            cancelledSubtitle: 'Vous avez annulé le versement. Vous pouvez le relancer à tout moment depuis votre espace membre.',
            notFinalizedTitle: 'Versement non finalisé',
            notFinalizedSubtitle: 'Le versement n\'a pas été finalisé. Vous pouvez relancer un versement depuis votre espace membre ou choisir un autre mode de paiement.',
            returnCode: 'Code retour :',
            errorTitle: 'Erreur',
            errorSubtitle: 'Nous n\'avons pas identifié le retour du paiement, merci de prendre contact avec le support.',
        },
    },
    en: {
        common: {
            previous: 'Previous',
            next: 'Next',
            incomplete: 'Incomplete',
            completeForm: 'Please complete the form.',
            email: 'Email',
            back: 'Back',
            loading: 'Loading...',
            loadingData: 'Loading data...',
            validate: 'Validate',
            cancel: 'Cancel',
            confirmChoice: 'Do you want to confirm your choice?',
            completeInfo: 'Please complete this information',
            supportContactError: 'Error, please contact support at {email}',
            searchPlaceholder: 'Type to search…',
            noResult: 'No match found',
        },
        footer: {
            copyright: 'Copyright {year} - {brand}',
            privacy: 'Privacy',
            terms: 'Terms & conditions',
            legal: 'Legal notice',
            security: 'Transaction security',
        },
        menu: {
            dashboard: 'Dashboard',
            profile: 'My Profile',
            projects: 'My Projects',
            contact: 'Contact',
            help: 'Help',
            logout: 'Logout',
        },
        header: {
            welcome: 'Welcome!',
            registrationStart: 'Your registration can begin',
            backToSite: 'Back to website',
            myAccount: 'My account',
        },
        fil: {
            step1: 'Step 1',
            step2: 'Step 2',
            step3: 'Step 3',
            chooseProject: 'I choose my project',
            globalongAccount: '{brand} account',
            createFile: 'Creating my file',
        },
        recap: {
            makeChoice: 'Please make your choice',
            amountToPay: 'Amount to pay:',
            totalAmountToPay: 'Total amount to pay for this project:',
            yourSummary: 'Your summary',
        },
        ident: {
            accessError: 'Access error',
            checkCredentials: 'Please check your email or password.',
            provideEmail: 'Please provide your email.',
            sendNewPassword: 'Send my new password',
            passwordSent: 'Password sent',
            password: 'Password',
            passwordRequired: 'Your password is required.',
            login: 'Login',
            forgotPassword: 'Forgot password?',
            applyFirstProject: 'Apply for your first project',
            applyProject: 'Apply for a project',
        },
        dashboard: {
            projectTitle: 'Project: Aid and support for hospitalized children',
            weNeedYou: 'We need you',
            lastStep: 'One last step before submitting your application.',
            refPrefix: 'Ref. #',
            departurePrefix: 'Departure on ',
            finalizeApplication: 'Finalize my application',
            clickToFinalize: 'Click here to finalize my application',
            noRegistration: 'No pending registration',
            noRegistrationDesc: 'You have no registration awaiting submission',
            greeting: 'Hello {name} ;)',
            followRegistrations: 'Track your registrations and access your personal information from the left menu.',
        },
        orderDashboard: {
            mySteps: 'My steps',
            registrationStatus: 'Status of your registration & payment',
            actionRequired: 'Action required: Membership fee payment',
            actionRequiredSolde: 'Action required: Registration fee balance payment',
            lclPayment: 'Secure card payment',
            lclPaymentDesc: 'To pay by credit card, please click one of the icons below. Allow 1 to 4 business days for our team to validate your payment. After this delay, if you have not received a confirmation email, please contact us.',
            stripePayment: 'Secure card payment',
            stripePaymentDesc: 'Pay online securely by credit card. By clicking the button below, you will be redirected to our payment provider Stripe to complete your payment. You will receive a confirmation email once the payment is made.',
            payWithStripe: 'Pay by credit card',
            mobilepayPayment: 'Secure payment via MobilePay',
            mobilepayPaymentDesc: 'Pay online securely with MobilePay (Vipps). By clicking the button below, you will be redirected to MobilePay to complete your payment. You will receive a confirmation email once the payment is made.',
            payWithMobilepay: 'Pay with MobilePay',
            wireTransfer: 'Payment by bank transfer',
            wireTransferDesc: 'To make a bank transfer payment, use our bank details, which you will receive by email, and proceed with the transfer via your online bank or in your bank branch.',
            wireTransferWarning: 'Warning: this is not a direct debit, you must initiate the transfer with your bank.',
            wireTransferConfirm: 'You will receive a confirmation email upon reception of your payment on our account. This may take a few days. If you have not received the confirmation email within 7 days, please contact us.',
            validateWireTransfer: 'Validate my bank transfer payment',
            checkPayment: 'Payment by check',
            checkPaymentDesc1: 'If you wish to pay by bank check, you have 15 days to send and for us to receive the check. After this deadline, without receipt of your check(s), the payment method will be cancelled and you will have to start over.',
            checkPaymentDesc2: 'For validation of your check payment, allow approximately 15 days after we receive your check. You will then receive a confirmation email. If you have not received a confirmation email after 15 days, please contact our team.',
            checkPaymentWarning: 'Warning: payment by check is not possible if your program starts in less than 8 weeks. In this case, please make the payment by credit card or bank transfer.',
            validateCheckPayment: 'Validate my check payment',
            cotisationHappy: 'We are pleased to inform you that your application has been accepted.',
            cotisationP1: 'To validate your commitment, please pay the membership fee ({membershipFee}) to become a member of the {brand} association. Membership is valid for 1 year, renewable free of charge for 9 years.',
            cotisationP2: 'Once payment is made, we will process your registration and you will receive all documents and information needed to prepare your project.',
            thirdPartyQuestion: 'A third party wants to make a payment for my project, how can they do it?',
            thirdPartyIntro: 'The majority of our volunteers raise funds from third parties or companies to finance their project. This can be done in the following ways:',
            thirdPartyOption1: '1. By credit card via your member space',
            thirdPartyOption2: '2. By bank transfer - in this case, you receive our bank details by email and donors can make one or more transfers to our account, indicating your first and last name in the transfer reference',
            thirdPartyOption3: '3. By check, indicating in the letter that the payment is for your application',
            processingDelay: 'Processing time will depend on the chosen payment method.',
            contactHelp: 'If you have questions or need help with the next steps, please contact us by email or book a phone appointment',
            contactHelpLink: 'via this link.',
            acompteP1: 'To validate your commitment, please pay a first part of the solidarity budget ({membershipFee}) so we can begin organizing your project. This amount will be deducted from the total amount we are responsible for raising for your project.',
            acompteP2: 'This is not the association membership fee, which you have already paid (and which has already been deducted), but a partial payment of the contribution for this project.',
            soldePay: 'Please pay the remaining balance of {amount}',
            paymentPending: 'Payment pending validation',
            thanksPayment: 'Thank you for your payment and your trust.',
            uponReception: 'Upon receipt of your payment on our account, we will validate your {brand} space and send you a receipt confirmation.',
            wireTransferTitle: 'Payment by bank transfer:',
            notDirectDebit: 'a direct debit - please contact your bank to make your transfer to the account whose details (IBAN) are as follows:',
            notDirectDebitPrefix: 'This is not',
            bankColumn: 'Bank',
            codeColumn: 'Code',
            accountColumn: 'Account number',
            ribKey: 'IBAN key',
            domiciliation: 'Branch',
            accountHolder: 'Account holder:',
            intlIdent: 'INTERNATIONAL IDENTIFICATION',
            wireLabel: 'In the bank transfer description, please note your first and last name as well as the destination and reference of your project.',
            bankFees: 'Warning: if currency exchange or bank transaction fees apply, you are responsible for paying them.',
            contactByEmail: 'For any questions, contact us by email at',
            checkTitle: 'Payment by check (French checks only):',
            checkInstruction: 'For payment by check, please send your check(s), made out to "{bankCheckPayee}", to the following address:',
            assocAddressLine1: '{bankAddressLine1}',
            assocAddressLine2: '{bankAddressLine2}',
            assocAddressLine3: '{bankAddressLine3}',
            checkOriginWarning: 'Please note that we only accept checks from French banks. We cannot accept foreign checks. Warning: check payment is not possible if your program starts in less than 8 weeks, due to processing times. In this case, please pay by credit card or bank transfer.',
            markName: 'Remember to write your first and last name as well as your application reference on the back of the check.',
            backToSteps: 'Back to steps',
            cotisationOrAcompte: 'Membership fee payment / Deposit payment',
            remainingBalance: 'Remaining balance payment',
            applicationToComplete: 'Application to complete',
            applicationInReview: 'Application under review',
            applicationAccepted: 'Application accepted',
            cotisationPendingValidation: 'Membership fee / deposit payment pending validation by our team (1 to 7 days depending on payment method)',
            firstPaymentValidated: 'First payment received and validated by our team',
            balancePendingValidation: 'Remaining balance payment pending validation by our team (1 to 7 days depending on payment method)',
            balanceValidated: 'Remaining balance payment received and validated by our team',
            projectFinalized: 'Project finalized',
            stripeInitError: 'Error while initializing the Stripe payment.',
            stripeConnectError: 'An error occurred while connecting to Stripe. Please try again.',
            mobilepayInitError: 'Error while initializing the MobilePay payment.',
            mobilepayConnectError: 'An error occurred while connecting to MobilePay. Please try again.',
        },
        order: {
            myProjects: 'My projects list',
            projectsDesc: 'Below you will find your applications, future projects, ongoing projects, past projects and cancelled projects. ',
            tabApplications: 'Applications',
            tabInProgress: 'My ongoing projects',
            tabFinished: 'Completed projects',
            tabCancelled: 'Cancelled applications/projects',
            titleApplications: 'My applications',
            titleValidated: 'My validated projects',
            titleFinished: 'Completed projects',
            titleCancelled: 'Cancelled applications/projects',
        },
        orderDetail: {
            myProjectPrefix: 'My project: ',
            programType: 'Program type:',
            project: 'Project:',
            applicationStatus: 'Application status:',
            startDate: 'Start date:',
            endDate: 'End date:',
            totalBudget: 'Total budget for your project',
            amount: 'Amount',
            remainingAmount: 'Remaining amount to pay:',
            paymentDeadline: 'Payment deadline:',
            visaTitle: 'Current visa and immigration rules',
            visaDesc: 'Visa and immigration rules vary depending on your nationality. Please take the necessary steps to find out the rules that apply to your situation. You may also contact us to learn more.',
            tabStatus: 'Status',
            tabMyData: 'My data',
            tabMyDocuments: 'My documents',
            tabMyPayments: 'My payments',
            tabOutboundFlights: 'Outbound flight(s)',
            tabReturnFlights: 'Return flight(s)',
            completeApplication: 'Please complete your application',
            completeApplicationButton: 'Complete my application',
            supplement: 'Supplement: ',
        },
        orderBlocDetails: {
            profileUpdated: 'Your profile is updated, thank you.',
            passportNumber: 'Passport number',
            passportPlace: 'Place of issue of the passport',
            passportFullName: 'Exact name(s) and first name(s) on passport',
            passportIssueDate: 'Passport issue date',
            passportExpiry: 'Passport expiration date',
            visaNumber: 'Visa number',
            insuranceCompany: 'Travel insurance company',
            insurancePolicy: 'Travel insurance policy number',
            additionalNotes: 'Additional notes',
            validateInfo: 'Validate my information',
        },
        orderComplete: {
            applicationSubmitted: 'Your application has been submitted and will be reviewed shortly.',
            averageReviewTime: 'On average, applications are reviewed in less than 7 business days.',
            longerDelays: 'In some cases, the delays may be longer, do not hesitate to contact us if needed:',
            congratulations: 'Congratulations',
            accessMember: 'Access my member space',
            almostThere: 'We\'re almost there ^_^',
            afterValidation: 'After validation of this form, your application will be submitted to {brand}',
            submitApplication: 'Submit my application',
        },
        dashboardCmd: {
            startPrefix: 'Start on ',
            finalizeApp: 'Finalize the application',
            firstPaymentNeeded: 'Please proceed with the first payment to validate your registration.',
            acceptedProjects: 'Accepted project(s)',
            validateFirstPayment: 'Validate the first payment',
            infoAndDocs: 'Information (flights, visa etc.) and documents',
            completeInfoAndDocs: 'Please complete the information if not already done and submit the documents.',
            confirmedProjects: 'Confirmed project(s)',
            checkOrComplete: 'Check or complete my registration',
        },
        listeCmd: {
            reference: 'Reference: ',
            country: 'Country',
            notSpecified: 'Not specified',
            seeDetails: 'See details',
            validateLastStep: 'Click here to validate the last step of your application.',
            additionalInfoRequired: 'Additional information required',
        },
        orderFiles: {
            updateDocs: 'Updating your documents',
            checkingDocs: 'We are verifying receipt of your documents.',
            fileUploaded: 'Thank you, your file has been uploaded.',
            fileFormat: 'The file must be PDF, JPEG, PNG, DOC or DOCX (Word format)',
            maxSize: 'Must not exceed 35MB!',
            docTypeNotSpecified: 'Document type not specified',
            specifyDocType: 'Please specify the document type',
            fileAlreadyLoaded: 'The file is already loaded',
            fileAlreadyLoadedDesc: 'If you want to load it again, you will need to delete it first',
            uploadDocs: 'Upload your documents',
            docTypePlaceholder: 'Document type',
            internship: 'Internship agreement',
            planeTicket: 'Plane ticket',
            visa: 'Visa',
            other: 'Other',
            add: 'Add',
            docState: 'Status of submitted documents',
            legendStates: 'Status legend',
            docNotLoaded: 'Document not uploaded',
            docPendingValidation: 'Document pending validation by {brand}',
            docValidated: 'Document validated',
            docValidatedTooltip: 'Your document is validated',
            docPendingTooltip: 'Your document is pending',
            docNeedsUpload: 'Please upload the document',
            docsAvailable: 'Documents available:',
            missionDocs: 'Mission documents:',
        },
        orderFlight: {
            flightNum: 'Flight number',
            flightCompany: 'Flight company',
            takeoffDateTime: 'Takeoff date and time',
            arrivalDateTime: 'Arrival date and time',
            depAirport: 'Departure airport',
            arrAirport: 'Arrival airport',
            missingInfo: 'Missing information',
            missingInfoSingular: 'Missing information',
            update: 'Update',
            delete: 'Delete',
            addFlight: 'Add a flight',
            numAndCompany: 'Number and company',
            iLeaveFrom: 'I leave from ',
            iArriveAt: 'I arrive at',
            depAirportPlaceholder: 'Departure airport (last airport before arrival)',
            takeoffPlaceholder: 'Takeoff date and time',
            landingPlaceholder: 'Landing date and time',
            validateFlights: 'Validate my flights',
            myFlights: 'My flights list',
            loading: 'Loading...',
            notif: 'Notification ',
            flightsAdded: 'Flight(s) added.',
            flightUpdated: 'Your flight has been updated with the new information.',
            additionalInfo: 'Additional information',
            giveDetails: 'Please give us additional details',
            selectReason: 'Please select a reason.',
            cancelMyReason: 'Cancel my reason ',
            reasonUpdated: 'Reason updated',
            reasonUpdatedDesc: 'We confirm the update of the reason.',
            reasonCancelled: 'Reason cancelled',
            reasonCancelledDesc: 'We confirm the cancellation of the reason.',
            outboundHeader: 'I arrive in the country before the mission and do not need a pickup at the airport',
            returnHeader: 'I stay in the country after the mission and do not need to be driven back to the airport',
            importantInfo: 'IMPORTANT – Please strictly respect the arrival and departure days and times indicated in the documents available in your member area.',
            contactBeforeBuy: 'If in doubt or if you have a question, do not hesitate to contact us before purchasing your ticket.',
            outboundReasonTitle: 'If you cannot meet the departure dates and times scheduled for the mission, and your program includes a return to the airport (please check your project conditions), please choose one of the following options:',
            outboundReason1: 'Early arrival without pickup: I will be in the country before the start of the mission and do not need a pickup at the airport. I will contact the local team to organize my arrival independently',
            outboundReason2: 'Early arrival with exceptional pickup: I will be in the country before the start of the mission and would like a pickup at the airport, as well as additional nights (subject to availability, additional fees may apply)',
            outboundReason3: 'Late arrival with delayed pickup: I arrive after the originally planned date and request a delayed pickup at the airport (subject to availability, additional fees may apply)',
            returnReasonTitle: 'If you cannot meet the arrival dates and times scheduled for the mission, and your program includes a pickup at the airport (please check your project conditions), please choose one of the following options:',
            returnReason1: 'Early departure with exceptional escort: I will leave the country before the end of the mission and would like an escort to the airport (subject to availability, additional fees may apply)',
            returnReason2: 'Late departure with delayed escort: I will leave the country after the originally planned date and request a delayed escort to the airport and additional nights at the accommodation (subject to availability, additional fees may apply)',
            returnReason3: 'Extended stay for personal travel: I will stay in the country after the end of the mission to travel and will not need to be driven back to the airport',
        },
        orderMsg: {
            backToOrder: 'Back to my order',
            paymentRegistered: 'Payment registered',
            paymentRegisteredDesc: 'Thank you, we will quickly verify your payment.',
            paymentRefused: 'Payment not accepted',
            paymentRefusedDesc: 'Your payment was not finalized, please contact {brand} support or your bank.',
            error: 'Error',
            errorDesc: 'We did not identify the order response, please contact support.',
        },
        orderTransactions: {
            declarationSent: 'Thank you, your declaration has been submitted',
            lastName: 'Last name',
            firstName: 'First name',
            fillInfo: 'Please fill in this information',
            denomination: 'Denomination',
            legalForm: 'Legal form',
            siren: 'SIREN',
            multiDonators: 'If several people have made donations for your project, for example via an online crowdfunding, please contact us by phone or email to know the procedure to obtain tax receipts.',
            youAre: 'You are',
            individual: 'An individual',
            company: 'A company',
            emailInvalid: 'The email format is incorrect or not provided.',
            streetNumber: 'Street number',
            streetName: 'Street name',
            postalCode: 'Postal Code',
            city: 'City',
            paymentDate: 'Payment date',
            confirmCheck: 'Please check this box to confirm your entry',
            declarationStatement: 'I, the undersigned (First name and Last name of the customer), hereby declare on my honor that the information provided in this declaration is accurate and complete.',
            validateDeclaration: 'Validate your declaration',
            id: 'Id',
            amount: 'Amount',
            date: 'Date',
            state: 'Status',
        },
        contact: {
            contactUs: 'Contact us',
            desc1: 'You can send us a message via the form below, we will reply by email as soon as possible.',
            desc2: 'You can also book a phone appointment via this link: ',
            desc3Before: ' or call us at ',
            desc3After: ' during our opening hours.',
            desc4: 'If you are on a mission, please contact your coordinator first for any emergency.',
            sendMyMsg: 'Send my request',
            msgSent: 'Thank you, we confirm receipt of your message, you will get a reply very soon!',
        },
        passport: {
            formSent: 'Form sent successfully!',
            formError: 'Error sending the form',
            fillAllFields: 'Please fill in all fields correctly.',
            alreadyOrdered: 'Order already placed',
            alreadyOrderedDesc: 'Your volunteer passport order has already been submitted.',
            orderSuccess: 'Order successful',
            orderSuccessDesc: 'Your volunteer passport order has been sent successfully. Thank you for your trust!',
            getFreeTitle: 'Get your volunteer passport for free!',
            getFreeDesc: 'This official document allows you to highlight your volunteer experience and have the skills you have acquired recognized. Recommended by employers and associations, it is an asset for your personal and professional journey. {brand} offers it to you, including shipping costs.',
            clickToReceive: 'Click below to receive it now!',
            learnMore: 'Learn more: ',
            volunteerPassport: 'The Volunteer Passport',
            orderMyPassport: 'Order my volunteer passport',
            orderTitle: 'Order your volunteer passport',
            civility: 'Title',
            selectCivility: 'Please select your title.',
            selectCivilityPlaceholder: 'Select your title',
            enterName: 'Please enter the last name.',
            enterFirstName: 'Please enter the first name.',
            phone: 'Phone',
            enterPhone: 'Please enter the phone number.',
            numberPlaceholder: 'Number',
            streetAndNum: 'Street number and name',
            enterStreet: 'Please enter the street.',
            street: 'Street',
            postalCode: 'Postal code',
            enterPostalCode: 'Please enter the postal code.',
            enterCity: 'Please enter the city.',
            countryFranceOnly: 'Country (Only available in France)',
            selectCountry: 'Please select the country.',
            countryPlaceholder: 'Select your country',
            formNotice: 'The information collected on this form is stored in a computerized file by the {brand} association for sending the document by mail.',
            acceptTerms: 'You must accept the terms to continue.',
            acceptDataUse: 'I accept that my data be used for sending the document by mail.',
            validateOrder: 'Validate the volunteer passport order',
        },
        memberAdhesion: {
            updateError: 'Error updating the member',
            renewError: 'Error renewing the membership',
            networkError: 'Network error while renewing the membership',
            confirmationRequired: 'Annual membership confirmation required',
            adhesionValidity: 'Your membership remains valid for 9 years, at no additional cost. Please confirm that you still wish to be part of our association.',
            renewAdhesion: 'Renew membership',
        },
        profil: {
            title: 'Your information',
            desc: 'You can edit some of your information from this page. To update information that cannot be modified, please contact us by email. ',
            usernameRequired: 'Please input your username!',
            mr: 'Mr.',
            mme: 'Mrs.',
            password: 'Password',
            providePassword: 'Please enter your password.',
            passwordMinLength: 'Your password must be at least 8 characters long.',
            confirmPassword: 'Confirm password',
            confirmPasswordRule: 'Please confirm your password.',
            samePasswordRule: 'Please enter the same password for confirmation.',
            birthDate: 'Date of birth',
            nationality: 'Nationality',
            address: 'Address',
            cp: 'Postal code',
            mobilePhone: 'Mobile phone',
            landline: 'Landline',
            proSituation: 'Current professional situation',
            facebook: 'Facebook',
            remarks: 'Remarks',
            emailTrackingConsent: 'I agree that {brand} may measure the opening of its emails (via a tracking pixel) in order to improve the relevance of its communications. This tracking is optional and can be revoked at any time.',
            loading: 'loading...',
        },
        formRegister: {
            emailExists: 'An account already exists with this email address, please request a new password via "Lost password"',
            missingInfo: 'Some information is missing, please complete the form.',
            emailTrackingConsent: 'I agree that {brand} may measure the opening of its emails (via a tracking pixel) in order to improve the relevance of its communications. This tracking is optional and can be revoked at any time from my profile.',
            thanksCreated: 'Thank you for creating your {brand} space. ',
            spaceAllowsYou: 'Your {brand} space allows you to:',
            allow1: 'Apply for a volunteer project or register for a language course',
            allow2: 'Communicate with our team',
            allow3: 'Provide us with important information about your project',
            allow4: 'Download important documents for preparing your project',
            allow5: 'Provide us with the essential documents before your arrival in the host country',
            allow6: 'Pay the membership fee and make donations',
            navigationHelp: 'By navigating the menu on the left of your {brand} space, you can edit your profile, complete your information, see the status of your application and payments, or contact us.',
            moreInfo: 'For more information, please contact us at',
            phoneAppointment: 'We can also arrange a phone appointment to discuss in person.',
            clickAvailability: 'Click here to see our availability',
            andBook: 'and book.',
            bestRegards: 'Best regards,',
            globalongTeam: 'The {brand} team',
            backToRegistration: 'Back to registration',
            title: 'Registration form',
            dateFormat: 'Date in format MM/DD/YYYY',
            countryBirth: 'Country of birth',
            validEmail: 'Please enter a valid email',
            permanentAddress: 'Permanent address',
            phonePrefixRequired: 'Phone code is required',
            preferredPrefixes: 'Common codes',
            allCountries: 'All countries',
            phoneExample: 'Example: 06XXXXXXXX',
            emergencyContact: 'Emergency contact person',
            volunteerLink: 'Relationship to the volunteer',
            emergencyPhone: 'Emergency phone',
            emergencyEmail: 'Emergency email',
            proSection: 'Your professional situation',
            currentProSituation: 'Your current professional situation',
            otherProSituation: 'If you cannot find your current professional situation in the list above, please specify',
            departureProSituation: 'Your situation at departure (if different)',
            otherDepartureProSituation: 'If you cannot find your professional situation at departure in the list above, please specify',
            termsAcceptIntro: 'I have read and accept the ',
            termsLabel: 'terms and conditions',
            withoutReserve: ' without reservation, I have read the ',
            legalNoticeLabel: 'legal notice',
            committedTo: ' and I commit to respecting the ',
            internalRulesLabel: 'internal rules',
            yesAccept: 'Yes, I accept',
        },
        methodeReg: {
            noAccount: 'I don\'t have an account',
            createAccount: 'Create my account',
            haveAccount: 'I already have an account',
            signIn: 'Sign in',
        },
        step1: {
            registrationTitle: 'Off we go! Your registration ;)',
            infoNotes: 'Informational notes',
            infoNotesDesc: 'We can only review one application per dates per person.\nIt is not possible to apply for several projects on the same dates.\nIf the application for your first choice is not retained, you can apply for other projects, and we will be there to guide you.\nFor any questions, do not hesitate to contact us. ',
            stepOf: 'Step 1/3',
            chooseProjectDateDuration: 'I choose my project, start date and duration ',
        },
        step3: {
            accountCreation: 'Account creation',
            almostThere: 'We\'re almost there!',
        },
        orderCheck: {
            startDatePrefix: 'Start date: ',
            destinationCountryPrefix: 'Destination country: ',
            programTypePrefix: 'Program type: ',
            programNamePrefix: 'Program name: ',
            engagementDurationPrefix: 'Engagement duration: ',
            supplementPrefix: 'Supplement: ',
            totalDurationPrefix: 'Total duration of your project: ',
            weeks: ' week(s)',
            amountLib: 'Amount to pay ',
            totalAmountLib: 'Total amount to pay ',
            forThisProject: 'for this project if your application is accepted: ',
            questionPrefix: 'Question: ',
            answerPrefix: ' / Your answer: ',
            additionalAnswerPrefix: '/ Additional: ',
            recapTitle: 'Application summary',
            recapDesc: 'This step is the last one and will allow us to give you the main information about your registration',
            projectDetails: 'Your project details',
            questionsAndAnswers: 'Questions and answers',
            backToPreviousStep: 'Back to previous step',
            openApplication: 'Open my application file',
        },
        inscrTermine: {
            hello: 'Hello {name},',
            confirmedTitle: 'File opening confirmed',
            langueOpening: 'You just opened a file to apply for a project with the {brand} association and we thank you for your trust.',
            validateBelow: 'Please validate your application below.',
            responseDelay: 'You will receive a response within 1 to 7 business days. In the meantime, contact us if you have any questions.',
            mustComplete: 'To finalize the application, you must submit an application file by uploading the documents listed above via your member area.',
            applicationContent: 'Your file must consist of:',
            yourCV: '1. Your CV',
            presentationLetterIntro: '2. A cover letter answering the following questions:',
            whyLeave: 'Why do you want to go?',
            whyCountry: 'Why did you choose this country and this project?',
            qualifications: 'What qualifications or experience related to the mission do you have?',
            expectations: 'What do you expect from the mission?',
            criminalRecord: '3. For volunteering and internships: a criminal record extract.',
            documentsLanguageTitle: 'The letter and CV must imperatively be written:',
            documentsLanguageFr: '- in French for Togo, Morocco, Madagascar and Senegal',
            documentsLanguageEs: '- in Spanish for Spanish-speaking countries (or in English if you are a beginner in Spanish)',
            documentsLanguageEn: '- in English for all other destinations',
        },
        dateOpen: {
            packsAvailable: 'Available packs',
            datesAvailable: 'Available dates',
            full: ' (Full)',
            clickToChooseWeeks: 'Click here to choose the duration in number of weeks',
            chooseEngagementDuration: 'Choose your engagement duration',
            otherDurationContact: 'For any other duration, contact us',
            whenStart: 'Around what date would you like to start?',
            closestDatesList: 'List of dates closest to your choice',
            selectDateToContinue: 'Please select a date to be able to proceed to the next step',
        },
        docsInscr: {
            mustBeWrittenIn: 'Your documents must be written in: ',
            languageTitle: 'Document language',
            missingDocs: 'Missing documents',
            cvAndLetterRequired: 'The CV and cover letter are required',
            requiredDocs: 'Required documents',
            participateIntro: 'To participate in a volunteer program, international volunteering or an internship abroad, you must build an application file by uploading the documents above.',
            applicationConsistOf: 'Your file must consist of:',
            yourCV: '1. Your CV',
            letterIntro: '2. A cover letter answering the following questions:',
            whyVolunteer: '* Why do you want to volunteer?',
            whyCountryMission: '* Why did you choose this country and this mission?',
            qualifications: '* What qualifications or experience related to the mission do you have?',
            expectations: '* What do you expect from the mission?',
            whenStart: '* When do you want to start?',
            howManyWeeks: '* How many weeks do you want to go for?',
            criminalRecord: '3. A criminal record extract.',
            languageIntro: 'The letter and CV must imperatively be written:',
            languageFr: '- in French for Togo, Morocco, Madagascar and Senegal',
            languageEs: '- in Spanish for Spanish-speaking countries (or in English if you are a beginner in Spanish)',
            languageEn: '- in English for all other destinations',
            cvLib: 'CV',
            letterLib: 'Cover letter',
            criminalRecordLib: 'Criminal record',
            criminalRecordInfoTitle: 'Criminal record information',
            criminalRecordInfoDesc: 'The criminal record is not essential at this stage of the application, but must be provided before the start of your project. The other documents (CV and cover letter) are required.',
        },
        accompagnateur: {
            withOthers: 'Are you applying with one or more people?',
            individualApp: 'Please note that each person must submit an individual application. Make sure to apply for the same mission, on the same dates.',
            yourCompanions: 'Your companions',
            erase: 'Remove',
            updated: 'Companion updated',
            updatedDesc: 'The companions information has been updated.',
            addNewPerson: 'Add a new person',
            missingFirstName: 'First name is missing',
            missingLastName: 'Last name is missing',
            missingEmail: 'Email is missing',
            addPerson: 'Add a person',
            validateCompanions: 'Validate my companions',
        },
        contactTel: {
            previousContact: 'Have you already had phone contact with the {brand} association?',
            choice: 'Choice',
            yes: 'yes',
            no: 'no',
            bookAppt: 'Please book a phone appointment at your convenience via this link: ',
            whileWaiting: 'While waiting for the phone exchange, you can continue by pressing "next" and submit your application :)',
        },
        questionBloc: {
            chooseAnswer: 'Choose my answer',
            specifyAnswer: 'Please specify your answer',
            required: 'This information is required',
            subQuestionsUnavailable: 'Sub-questions not available',
        },
        questions: {
            pleaseAnswer: 'Please answer the questions',
            loading: 'Loading....',
        },
        blockSejour: {
            selected: 'Stay selected',
            selectThis: 'Select this program',
        },
        choixTypeSejour: {
            chooseType: 'I choose my project type',
            combined: 'Combined',
            combinedDesc: 'To combine a language course with a volunteer project or an internship',
            volunteer: 'Volunteering',
            volunteerDesc: 'To apply for a volunteer mission or an internship',
            language: 'Language course',
            languageDesc: 'To learn or improve a foreign language',
        },
        supp: {
            optionalSupplements: 'Optional add-ons',
        },
        choixSejour: {
            programChoice: 'Choose your program',
        },
        destination: {
            title: 'My destination',
            choose: 'Choose',
        },
        step2: {
            titleHeader: 'Step 2/3',
            subtitle: 'We need to get to know you a little better',
        },
        home: {
            backToSite: 'Back to the {brand} website',
        },
        stripeReturn: {
            backToOrder: 'Back to my order',
            successTitle: 'Payment successful',
            successSubtitle: 'Thank you, your card payment (Stripe) has been successfully recorded. You will receive a confirmation email shortly.',
            cardDeclinedTitle: 'Card declined',
            cardDeclinedSubtitle: 'Your card was declined by your bank. Please try again with another card or contact your bank.',
            expiredTitle: 'Card or session expired',
            expiredSubtitle: 'Your card or payment session has expired. Please initiate a new payment with a valid card from your member area.',
            insufficientFundsTitle: 'Insufficient funds',
            insufficientFundsSubtitle: 'Your card does not have sufficient funds to complete this payment. Please try again with another card or contact your bank.',
            incorrectCvcTitle: 'Incorrect security code',
            incorrectCvcSubtitle: 'The security code (CVC) you entered is incorrect. Please check your card details and try again.',
            incorrectNumberTitle: 'Incorrect card number',
            incorrectNumberSubtitle: 'The card number you entered is incorrect. Please check your card details and try again.',
            processingErrorTitle: 'Processing error',
            processingErrorSubtitle: 'An error occurred while processing your payment. Please try again in a few moments.',
            authRequiredTitle: 'Authentication required',
            authRequiredSubtitle: 'Your bank requires additional authentication (3D Secure) which was not completed. Please restart the payment and complete authentication with your bank.',
            doNotHonorTitle: 'Payment declined by your bank',
            doNotHonorSubtitle: 'Your bank declined the operation without a specific reason. Please contact your bank or try again with another card.',
            unusableCardTitle: 'Card cannot be used',
            unusableCardSubtitle: 'This card cannot be used for this payment. Please use another card or contact your bank.',
            tryAgainTitle: 'Please try again later',
            tryAgainSubtitle: 'The payment could not be processed by your bank. Please try again in a few minutes.',
            cancelledTitle: 'Payment cancelled',
            cancelledSubtitle: 'You cancelled the payment. You can restart it at any time from your member area.',
            notFinalizedTitle: 'Payment not completed',
            notFinalizedSubtitle: 'The payment was not completed. You can restart a payment from your member area or choose another payment method.',
            returnCode: 'Return code:',
            errorTitle: 'Error',
            errorSubtitle: 'We could not identify the payment return, please contact support.',
        },
    },
};
